import { VcaChecklistStep } from './VcaChecklistStep';
import { VcaClinicMessagesStep } from './VcaClinicMessagesStep';
import type { VcaCheckStepConfig } from './vca-check-step';

interface VcaCheckStepProps {
    config: VcaCheckStepConfig;
    confirmed: boolean;
    onChange: (confirmed: boolean) => void;
}

function VcaCheckStep({ config, confirmed, onChange }: VcaCheckStepProps) {
    if (config.kind === 'clinicMessages') {
        return (
            <VcaClinicMessagesStep
                warning={config.warning}
                checked={confirmed}
                onChange={onChange}
            />
        );
    }
    return <VcaChecklistStep signedOff={confirmed} onChange={onChange} />;
}

export { VcaCheckStep };
